import { styled } from "@mui/material/styles";

// Components
import { Typography } from "@mui/material";

const AuthTitle = styled(Typography)({
  "&": {
    textAlign: "start",
    fontSize: "2rem",
    fontFamily: "'Andika', sans-serif",
    height: "30px",
  },
});

export default AuthTitle;
